import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface HardwareReq {
  /** 终端设备id */
  device_id: string
}

export interface HardwareRes {
  /** 计算机型号 */
  computer_model: string
  /** cpu */
  cpu: string
  /** 主板 */
  main_bord: string
  /** sn码 (主机序列号) */
  sn_code: string
  /** 内存容量 */
  memory_capacity: number
  /** 内存信息 */
  memory_info: string
  /** 硬盘 */
  hard_disk: string
  /** 显卡 */
  graphics_card: string
  /** 网卡 */
  network_card: string
  /** 显示器 */
  display: string
  /** 声卡 */
  audio_card: string
}

@Injectable()
export class HardwareInfoService {
  constructor (private http: Http) {
  }

  getHardware (data: HardwareReq) {
    return this.http.post<HardwareRes>('/terminal/hardware/get', data)
  }
}
